import { CommonLayout } from '../commonComponents';
import {
    Route,
    Switch,
    useRouteMatch
} from 'react-router-dom';
import OrderEntry from './orderEntry';
import OrderDashboard from './orderDashboard';
import ProtectedRoute from '../../routes/ProtectedRoute';


// const routerList = [
//     {
//         name: 'Order Dashboard',
//         path: "order-dashboard",
//         component: OrderDashboard,
//     },
//     {
//         name: 'Order Entry',
//         path: "order-entry",
//         component: OrderEntry,
//     }
// ]

function OrderManagementRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {/* {
                routerList.map((item, index) => (
                    <Route
                        exact
                        key={index}
                        path={`${path}/${item.path}`}
                        component={item.component}
                    />
                ))
            } */}

            <ProtectedRoute
                exact
                path={`${path}/order-dashboard`}
                component={OrderDashboard}
                // acceptedRoles={[USER_ROLES.RM]}
                moduleCode="OrderDashboard"
                layout={CommonLayout}
            />
            <ProtectedRoute
                exact
                path={`${path}/order-entry`}
                component={OrderEntry}
                // acceptedRoles={[USER_ROLES.RM]}
                moduleCode="OrderEntry"
                layout={CommonLayout}
            />
        </Switch>
    );
}
export default function OrderManagementRouter(): JSX.Element {
    return (
        <>
            {/* <CommonLayout> */}
            <OrderManagementRoutes />
            {/* </CommonLayout> */}
        </>
    )
}